import Link from 'next/link'
import Meta from 'components/meta/meta'
import Panel from 'components/panel/panel'
import Or from 'components/or/or'
import SocialLogin from 'components/social-login/social-login'
import LoginForm from 'components/login-form/login-form'
import Heading from 'components/heading/heading'
import { getRoute } from 'utils/helpers'

export default function Page() {
    return (
        <>
            <Meta
                title="Prisijungimas"
                description="Šieme puslapyje galite prisijungti prie savo lietuviskapreke.lt naudotojo paskyros."
            />
            <Panel desktop size="small">
                <Heading tag="h1" size="30">
                    Prisijungimas
                </Heading>
                <SocialLogin />
                <Or />
                <LoginForm />
                <footer>
                    <p>
                        Dar nesate užsiregistravęs? <Link href={getRoute('registration')}>Registruotis</Link>
                    </p>
                    <p>
                        <Link href={getRoute('forgot-password')}>Pamiršote slaptažodį?</Link>
                    </p>
                </footer>
            </Panel>
        </>
    )
}
